function applyStringMask(value: string, mask: string): string {
  const digits = value.replace(/\D/g, '');
  let result = '';
  let digitIndex = 0;

  for (let i = 0; i < mask.length && digitIndex < digits.length; i++) {
    if (mask[i] === '9') {
      result += digits[digitIndex];
      digitIndex++;
    } else {
      result += mask[i];
    }
  }

  return result;
}

function applyRegExpArrayMask(
  value: string,
  masks: (string | RegExp)[],
): string {
  let result = '';

  for (let i = 0; i < value.length && i < masks.length; i++) {
    const pattern = masks[i];
    if (pattern instanceof RegExp) {
      if (pattern.test(value[i])) {
        result += value[i];
      }
    } else {
      result += value[i];
    }
  }

  return result;
}

export function applyMask(
  value: string,
  mask: string | (string | RegExp)[],
): string {
  if (!value) {
    return '';
  }

  if (typeof mask === 'string') {
    return applyStringMask(value, mask);
  }

  if (Array.isArray(mask)) {
    return applyRegExpArrayMask(value, mask);
  }

  return value;
}
